import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import react from 'react';
import axios from 'axios';
import {host} from '../../function/api'
export const appointmentStore = createAsyncThunk(
    'apointment/store',
    async(data, thunkAPI) => {
        try {
            const response = await axios.post(
                `${host}appointment`,
                data,
                {
                    headers: {
                        'Accept': 'Application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                    }
                }
            )

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const appointmentIndex = createAsyncThunk(
    'appointment/index',
    async(token, thunkAPI) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}appointment`,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${token}`
                }
            }) 

            return await response.data;
            
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)
const initialState = {
    error: null,
    loading: false,
    success: false,
    message: '',
    appointments: [],
    errorName: '',
    errorFamily: '',
    errorMobile: '',
    errorNationalCode: '',
}

const appointmentSlice = createSlice({
    name: 'apointment',
    initialState,
    reducers: {

    },
    extraReducers: {
        [appointmentStore.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.message = payload.message;
        },
        [appointmentStore.pending]: (state) => {
            state.loading = true;
        },
        [appointmentStore.rejected]: (state, { payload }) => {
            state.loading = false;
            state.success = false;
            if(payload.response.data.error) {
               state.errorName = payload.response.data.error.name
               state.errorName = payload.response.data.error.family
               state.errorMobile = payload.response.data.error.mobile
               state.errorNationalCode = payload.response.data.error.nationalCode
            } else if(payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        [appointmentIndex.fulfilled]: (state, action) => {
            state.loading = false;
            state.appointments = action.payload.data.data
        },
        [appointmentIndex.pending]: (state) => {
            state.loading = true;
        },
        [appointmentIndex.rejected]: (state, { payload }) => {
            state.loading = false;
            state.success = false
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        }
    }
})

export const {} = appointmentSlice.actions;
export default appointmentSlice.reducer;